// @ts-nocheck
import { CONFIG } from "~/config";
import { _ } from "~/i18n";

const INIT_TIME = CONFIG.searchOnboarding?.init_time || 3000;
const WRITE_TIME = CONFIG.searchOnboarding?.write_time || 100; // 150 [ms]
const REMOVE_WAIT_TIME = CONFIG.searchOnboarding?.remove_wait_time || 3500; // [ms]
const REMOVE_TIME = CONFIG.searchOnboarding?.remove_time || 60; // 10, 100 [ms]
const BETWEEN_WORDS_TIME = CONFIG.searchOnboarding?.between_words_time || 1500; // 800 [ms]
const WORDS = CONFIG.searchOnboarding?.words || [];
const INTERVAL_CYCLE_TIME = 10; // 10 [ms]
const STATES = {
	INIT: 5,
	WRITE: 0,
	REMOVE_WAIT: 1,
	REMOVE: 2,
	WAIT: 3,
};

export default class MapySearchOnboarding {
	_initText: string;

	_words: Array<string>;

	constructor(input: string, lang: string) {
		this._input = input;
		this._intervalId = null;
		this._current = null;
		this._wasClick = false;
		// eventy
		this._input.addEventListener("input", this, false);
		this._input.addEventListener("click", this, false);
		this._input.addEventListener("blur", this, false);
		this._settings = {
			writeTime: WRITE_TIME,
			removeWaitTime: REMOVE_WAIT_TIME,
			removeTime: REMOVE_TIME,
			betweenWordsTime: BETWEEN_WORDS_TIME,
		};
		this._disabled = false;
		this._initText = lang === "cs"
			? CONFIG.searchOnboarding?.init_text
			: _("search.onboarding");
		this._words = lang === "cs"
			? WORDS
			: [];

		this._reset();
	}

	handleEvent(event) {
		switch (event.type) {
			case "input":
				/*
				if (this._wasClick) return;
				this._set();
				*/
				this.disable();
				break;
			case "click":
				this._wasClick = true;
				this.end();
				break;
			case "blur":
				this._wasClick = false;
				this.start();
				break;
			default:
		}
	}

	disable() {
		if (this._disabled === false) {
			this._input.removeEventListener("input", this, false);
			this._input.removeEventListener("click", this, false);
			this._input.removeEventListener("blur", this, false);

			this._disabled = true;
			this._current = null;
			this.end();
		}
	}

	start() {
		if (this._intervalId || this._disabled || this._words.length === 0) {
			this._setValue(this._initText);

			return;
		}

		this._clearInterval();
		this._reset();

		this._intervalId = setInterval(() => {
			switch (this._current.state) {
				case STATES.INIT:
					if (this._current.initTime === 0) {
						this._setValue(this._current.word);
					} else if (this._current.initTime > 0 && this._current.initTime % INIT_TIME === 0) {
						this._current.initTime = 0;
						this._current.wordPos = this._current.word.length - 1;
						this._current.state = STATES.REMOVE;
					}

					this._current.initTime += INTERVAL_CYCLE_TIME;
					break;
				case STATES.WRITE:
					if (this._current.writeTime % this._settings.writeTime === 0) {
						// jsme na konci
						if (this._current.wordPos === this._current.word.length + 1) {
							this._current.state = STATES.REMOVE_WAIT;
							this._current.writeTime = 0;
							this._current.wordPos = this._current.word.length - 1;
						} else {
							this._setValue(this._current.word.substr(0, this._current.wordPos));
							this._current.wordPos++;
						}
					}
					this._current.writeTime += INTERVAL_CYCLE_TIME;
					break;
				case STATES.REMOVE_WAIT:
					// cekame
					if (this._current.removeWaitTime > 0 && this._current.removeWaitTime % this._settings.removeWaitTime === 0) {
						this._current.removeWaitTime = 0;
						this._current.state = STATES.REMOVE;
					}
					this._current.removeWaitTime += INTERVAL_CYCLE_TIME;
					break;
				case STATES.REMOVE:
					if (this._current.removeTime % this._settings.removeTime === 0) {
						this._setValue(this._current.word.substr(0, this._current.wordPos));
						this._current.wordPos--;
					}
					this._current.removeTime += INTERVAL_CYCLE_TIME;
					// jsme na zacatku
					if (this._current.wordPos < 0) {
						this._current.wordPos = 0;
						this._current.state = STATES.WAIT;
						this._current.removeTime = 0;
					}
					break;
				case STATES.WAIT:
					// cekame
					if (this._current.delayTime > 0 && this._current.delayTime % this._settings.betweenWordsTime === 0) {
						this._current.state = STATES.WRITE;
						this._current.delayTime = 0;
						// nove slovo
						this._current.word = this._getRandomWord();
					}
					this._current.delayTime += INTERVAL_CYCLE_TIME;
					break;
				default:
			}
		}, INTERVAL_CYCLE_TIME);
	}

	end() {
		this._clearInterval();
		this._setValue();
	}

	get currentWord() {
		return this._current && this._current.state !== STATES.INIT && this._current.state !== STATES.WAIT && this._current.word !== this._initText ? this._current.word : "";
	}

	_set() {
		const value = this._input.value.trim();

		if (value) {
			this._clearInterval();
		} else {
			this.start();
		}
	}

	_setValue(value) {
		this._input.placeholder = value || "";
	}

	_reset() {
		this._current = {
			state: STATES.INIT,
			word: this._initText,
			wordPos: 0,
			initTime: 0,
			writeTime: 0,
			removeWaitTime: 0,
			removeTime: 0,
			delayTime: 0,
		};

		this._setValue();
	}

	_clearInterval() {
		if (this._intervalId) {
			clearInterval(this._intervalId);
			this._intervalId = null;
		}
	}

	_getRandomWord() {
		return this._words[Math.random() * this._words.length >>> 0];
	}
}
